import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Title,
  Text,
  Button,
  Group,
  Stack,
  Card,
  MultiSelect,
  Box,
  Chip,
  SimpleGrid
} from '@mantine/core';
import { IconArrowLeft, IconSearch, IconSock } from '@tabler/icons-react';

const footAttributes = [
  // Size
  { value: 'small-feet', label: 'Small Feet', group: 'Size' },
  { value: 'large-feet', label: 'Large Feet', group: 'Size' },
  { value: 'medium-feet', label: 'Medium Feet', group: 'Size' },
  { value: 'petite-feet', label: 'Petite Feet', group: 'Size' },
  { value: 'big-feet', label: 'Big Feet', group: 'Size' },

  // Shape
  { value: 'fat-feet', label: 'Fat Feet', group: 'Shape' },
  { value: 'thin-feet', label: 'Thin Feet', group: 'Shape' },
  { value: 'wide-feet', label: 'Wide Feet', group: 'Shape' },
  { value: 'narrow-feet', label: 'Narrow Feet', group: 'Shape' },
  { value: 'curvy-feet', label: 'Curvy Feet', group: 'Shape' },

  // Skin Tone
  { value: 'tan-feet', label: 'Tan Feet', group: 'Skin Tone' },
  { value: 'fair-feet', label: 'Fair Feet', group: 'Skin Tone' },
  { value: 'dark-feet', label: 'Dark Feet', group: 'Skin Tone' },
  { value: 'olive-feet', label: 'Olive Feet', group: 'Skin Tone' },
  { value: 'brown-feet', label: 'Brown Feet', group: 'Skin Tone' },
  { value: 'pale-feet', label: 'Pale Feet', group: 'Skin Tone' },

  // Toe Shape
  { value: 'long-toes', label: 'Long Toes', group: 'Toe Shape' },
  { value: 'short-toes', label: 'Short Toes', group: 'Toe Shape' },
  { value: 'round-toes', label: 'Round Toes', group: 'Toe Shape' },
  { value: 'square-toes', label: 'Square Toes', group: 'Toe Shape' },
  { value: 'pointed-toes', label: 'Pointed Toes', group: 'Toe Shape' },
  { value: 'oval-toes', label: 'Oval Toes', group: 'Toe Shape' },

  // Toe Conditions
  { value: 'missing-toe', label: 'Missing Toe', group: 'Toe Conditions' },
  { value: 'extra-toe', label: 'Extra Toe', group: 'Toe Conditions' },
  { value: 'webbed-toes', label: 'Webbed Toes', group: 'Toe Conditions' },
  { value: 'curled-toes', label: 'Curled Toes', group: 'Toe Conditions' },
  { value: 'bunions', label: 'Bunions', group: 'Toe Conditions' },

  // Nails - Polish Colors
  { value: 'red-nail-polish', label: 'Red Nail Polish', group: 'Nail Polish' },
  { value: 'pink-nail-polish', label: 'Pink Nail Polish', group: 'Nail Polish' },
  { value: 'purple-nail-polish', label: 'Purple Nail Polish', group: 'Nail Polish' },
  { value: 'blue-nail-polish', label: 'Blue Nail Polish', group: 'Nail Polish' },
  { value: 'black-nail-polish', label: 'Black Nail Polish', group: 'Nail Polish' },
  { value: 'white-nail-polish', label: 'White Nail Polish', group: 'Nail Polish' },
  { value: 'gold-nail-polish', label: 'Gold Nail Polish', group: 'Nail Polish' },
  { value: 'silver-nail-polish', label: 'Silver Nail Polish', group: 'Nail Polish' },
  { value: 'nude-nail-polish', label: 'Nude Nail Polish', group: 'Nail Polish' },
  { value: 'neon-nail-polish', label: 'Neon Nail Polish', group: 'Nail Polish' },
  { value: 'glitter-nail-polish', label: 'Glitter Nail Polish', group: 'Nail Polish' },
  { value: 'matte-nail-polish', label: 'Matte Nail Polish', group: 'Nail Polish' },

  // Nail Art & Designs
  { value: 'french-manicure', label: 'French Manicure', group: 'Nail Art' },
  { value: 'gel-nails', label: 'Gel Nails', group: 'Nail Art' },
  { value: 'acrylic-nails', label: 'Acrylic Nails', group: 'Nail Art' },
  { value: 'nail-art', label: 'Nail Art', group: 'Nail Art' },
  { value: 'rhinestones', label: 'Rhinestones', group: 'Nail Art' },
  { value: 'charms', label: 'Charms', group: 'Nail Art' },
  { value: 'studs', label: 'Studs', group: 'Nail Art' },
  { value: 'gradient-ombres', label: 'Gradient/Ombré', group: 'Nail Art' },
  { value: 'marble-nails', label: 'Marble Nails', group: 'Nail Art' },
  { value: 'chrome-nails', label: 'Chrome Nails', group: 'Nail Art' },
  { value: 'floral-nails', label: 'Floral Nails', group: 'Nail Art' },
  { value: 'animal-print', label: 'Animal Print', group: 'Nail Art' },

  // Pedicure Types
  { value: 'spa-pedicure', label: 'Spa Pedicure', group: 'Pedicure Type' },
  { value: 'classic-pedicure', label: 'Classic Pedicure', group: 'Pedicure Type' },
  { value: 'gel-pedicure', label: 'Gel Pedicure', group: 'Pedicure Type' },
  { value: 'acupuncture-pedicure', label: 'Acupuncture Pedicure', group: 'Pedicure Type' },
  { value: 'hot-stone-pedicure', label: 'Hot Stone Pedicure', group: 'Pedicure Type' },
  { value: 'fish-pedicure', label: 'Fish Pedicure', group: 'Pedicure Type' },
  { value: 'paraffin-pedicure', label: 'Paraffin Pedicure', group: 'Pedicure Type' },

  // Foot Features
  { value: 'tattoos', label: 'Tattoos', group: 'Foot Features' },
  { value: 'piercings', label: 'Piercings', group: 'Foot Features' },
  { value: 'foot-jewelry', label: 'Foot Jewelry', group: 'Foot Features' },
  { value: 'ankle-bracelets', label: 'Ankle Bracelets', group: 'Foot Features' },
  { value: 'toe-rings', label: 'Toe Rings', group: 'Foot Features' },
  { value: 'pedicure-extras', label: 'Pedicure Extras', group: 'Foot Features' },

  // Sole Characteristics
  { value: 'soft-soles', label: 'Soft Soles', group: 'Soles' },
  { value: 'rough-soles', label: 'Rough Soles', group: 'Soles' },
  { value: 'calloused-soles', label: 'Calloused Soles', group: 'Soles' },
  { value: 'smooth-soles', label: 'Smooth Soles', group: 'Soles' },
  { value: 'ticklish-feet', label: 'Ticklish Feet', group: 'Soles' },
  { value: 'arched-feet', label: 'Arched Feet', group: 'Soles' },
  { value: 'flat-feet', label: 'Flat Feet', group: 'Soles' },
  { value: 'high-arches', label: 'High Arches', group: 'Soles' },

  // Foot Condition
  { value: 'moisturized-feet', label: 'Moisturized Feet', group: 'Condition' },
  { value: 'dry-feet', label: 'Dry Feet', group: 'Condition' },
  { value: 'perfumed-feet', label: 'Perfumed Feet', group: 'Condition' },
  { value: 'fresh-feet', label: 'Fresh Feet', group: 'Condition' },
  { value: 'dirty-feet', label: 'Dirty Feet', group: 'Condition' },
  { value: 'sweaty-feet', label: 'Sweaty Feet', group: 'Condition' },
  { value: 'warm-feet', label: 'Warm Feet', group: 'Condition' },
  { value: 'cool-feet', label: 'Cool Feet', group: 'Condition' },

  // Accessories
  { value: 'barefoot', label: 'Barefoot', group: 'Accessories' },
  { value: 'socks', label: 'Socks', group: 'Accessories' },
  { value: 'stockings', label: 'Stockings', group: 'Accessories' },
  { value: 'flip-flops', label: 'Flip Flops', group: 'Accessories' },
  { value: 'heels', label: 'Heels', group: 'Accessories' },
  { value: 'high-heels', label: 'High Heels', group: 'Accessories' },
  { value: 'stilettos', label: 'Stilettos', group: 'Accessories' },
  { value: 'flats', label: 'Flats', group: 'Accessories' },
  { value: 'sandals', label: 'Sandals', group: 'Accessories' },
  { value: 'boots', label: 'Boots', group: 'Accessories' },

  // Special
  { value: 'pregnant-feet', label: 'Pregnant Feet', group: 'Special' },
  { value: 'cosplay-feet', label: 'Cosplay Feet', group: 'Special' },
  { value: 'roleplay', label: 'Roleplay', group: 'Special' },
  { value: 'foot-worship', label: 'Foot Worship', group: 'Special' },
  { value: 'custom-requests', label: 'Custom Requests', group: 'Special' }
];

const groupedAttributes = footAttributes.reduce((acc, item) => {
  if (!acc[item.group]) {
    acc[item.group] = [];
  }
  acc[item.group].push(item);
  return acc;
}, {});

const BrowseCategoriesPage = () => {
  const navigate = useNavigate();
  const [selectedAttributes, setSelectedAttributes] = useState([]);

  const handleSearch = () => {
    if (selectedAttributes.length > 0) {
      const queryParams = selectedAttributes.join(',');
      navigate(`/princesses?attributes=${encodeURIComponent(queryParams)}`);
    } else {
      navigate('/princesses');
    }
  };

  const handleClear = () => {
    setSelectedAttributes([]);
  };

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        <Button
          variant="subtle"
          leftSection={<IconArrowLeft size="1rem" />}
          onClick={() => navigate('/')}
          w="fit-content"
        >
          Back to Home
        </Button>

        <Stack gap="md" align="center">
          <IconSock size={48} color="var(--mantine-color-pink-6)" />
          <Title order={1} ta="center">
            Browse Feet Categories
          </Title>
          <Text size="lg" ta="center" c="dimmed" maw={600}>
            Find the princess you are looking to spoil by searching for what you like.
          </Text>
        </Stack>

        <Card shadow="md" padding="xl" radius="md" withBorder>
          <Stack gap="xl">
            <Text fw={600} size="lg">
              Select your preferences (multiple selection):
            </Text>

            {Object.entries(groupedAttributes).map(([group, items]) => (
              <Box key={group}>
                <Text fw={500} mb="sm" c="grape">
                  {group}
                </Text>
                <SimpleGrid cols={{ base: 2, sm: 3, md: 4 }} spacing="xs">
                  {items.map((item) => (
                    <Chip
                      key={item.value}
                      value={item.value}
                      checked={selectedAttributes.includes(item.value)}
                      onChange={() => {
                        setSelectedAttributes((prev) =>
                          prev.includes(item.value)
                            ? prev.filter((v) => v !== item.value)
                            : [...prev, item.value]
                        );
                      }}
                      color="grape"
                      variant="outline"
                    >
                      {item.label}
                    </Chip>
                  ))}
                </SimpleGrid>
              </Box>
            ))}

            {selectedAttributes.length > 0 && (
              <Box>
                <Text fw={500} mb="sm">
                  Selected ({selectedAttributes.length}):
                </Text>
                <Text c="dimmed" size="sm">
                  {selectedAttributes.join(', ')}
                </Text>
              </Box>
            )}
          </Stack>
        </Card>

        <Group justify="center" gap="md">
          <Button
            variant="outline"
            color="grape"
            onClick={handleClear}
            disabled={selectedAttributes.length === 0}
          >
            Clear All
          </Button>
          <Button
            size="lg"
            color="grape"
            leftSection={<IconSearch size="1.2rem" />}
            onClick={handleSearch}
          >
            Search Princesses
          </Button>
        </Group>
      </Stack>
    </Container>
  );
};

export default BrowseCategoriesPage;
